import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';

import { min } from '../../../utils/breakpoints';
import StyledH3 from '../../Styled/StyledH3';

const StyledButton = styled(Button)`
  text-decoration: none;
  font-size: 14px;
  padding: 9px 45px !important;
  border-width: 2px;

  ${min.sm} {
    font-size: 16px;
  }
`;

const SignOutSettings = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <div>
      <StyledH3>Sign out</StyledH3>
      <StyledButton onClick={() => navigate('/sign-out')} className="p-0" variant="secondary">
        Sign out of {theme.language.appName}
      </StyledButton>
    </div>
  );
};

export default SignOutSettings;
